namespace RedBullMOBILE360.CustomerCare {
    export interface UnBlockedSMSCustomersForm {
        Msisdn: Serenity.StringEditor;
        CreationDate: Serenity.DateEditor;
    }

    export class UnBlockedSMSCustomersForm extends Serenity.PrefixedContext {
        static formKey = 'CustomerCare.UnBlockedSMSCustomers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UnBlockedSMSCustomersForm.init)  {
                UnBlockedSMSCustomersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;

                Q.initFormType(UnBlockedSMSCustomersForm, [
                    'Msisdn', w0,
                    'CreationDate', w1
                ]);
            }
        }
    }
}
